export function setMainFopCollectionMaxDisplayFops({ state, action }) {
  const mainFopCollection = { ...state.mainFopCollection, maxDisplayFops: action.maxDisplayFops };
  return { ...state, mainFopCollection };
}

export function addRecommendedFopCollection({ state, action }) {
  return {
    ...state,
    recommendedFopCollection: action.recommendedFopCollection,
  };
}
